import React from 'react';
import NeuroSyncApp from "/Users/mohineesharma/Desktop/untitled folder 2/my-app/src/NeuroSyncApp";

function App() {
  return <NeuroSyncApp />;
}

export default App;